import { useSetRecoilState } from 'recoil';
import { forwardToDialogAtom } from '../recoil/atoms';

export type ForwardDialogArgs = {
  title: string;
  content: JSX.Element;
  open: boolean;
  submitText: string;
  redirectTo?: string;
  optionText?: string;
  optionRedirectTo?: string;
};

type HookReturns = [(value: boolean) => void];

export const useForwardToDialog = ({
  title,
  content,
  redirectTo,
  submitText,
  optionText,
  optionRedirectTo,
}: Omit<ForwardDialogArgs, 'open'>): HookReturns => {
  const setValues = useSetRecoilState(forwardToDialogAtom);

  const setOpened = (value: boolean) => {
    setValues({
      title,
      content,
      redirectTo,
      submitText,
      optionText,
      optionRedirectTo,
      open: value,
    });
  };

  return [setOpened];
};
